module.exports = __webpack_public_path__ + "static/media/A3.87b21ea5.mp3";